var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imgList)?_c('el-link',{attrs:{"type":"primary"},on:{"click":_vm.pre}},[_vm._v(" "+_vm._s(_vm.text || '查看图片')+" ")]):_c('span',[_vm._v("无")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }